import { observer } from 'mobx-react-lite';

import { LoadingRigOperations, WellRigOperationStage } from '../../../presets/drilling-wells-chart/entities';
import { WellsViewSettingsProvider } from '../../../presets/drilling-wells-chart/wells-view-settings-provider';
import { Viewport } from '../../../shared/viewport/viewport';
import { WellsChartDataModel } from '../../wells-chart/data/wells-chart-data-model';

import { WellsDataItemFull } from './wells-data-item-full';

interface Props {
  data: WellsChartDataModel.ViewItemContent[];
  horizontalViewport: Viewport;
  verticalViewport: Viewport;
  viewProvider: WellsViewSettingsProvider;
  onWellStageClick(wellId: number): void;
}

export const WellsDataItemsFull = observer(function WellsDataItemsFull({
  data,
  horizontalViewport,
  verticalViewport,
  viewProvider,
  onWellStageClick,
}: Props) {
  return (
    <>
      {data.map((item) => {
        if (item instanceof WellRigOperationStage || item instanceof LoadingRigOperations) {
          return (
            <WellsDataItemFull
              key={item.getKey()}
              item={item}
              horizontalViewport={horizontalViewport}
              verticalViewport={verticalViewport}
              viewProvider={viewProvider}
              onClick={onWellStageClick}
            />
          );
        }

        return null;
      })}
    </>
  );
});
